import { httpGet, httpUrl } from "../../api/httpClient";

export const fetchServerWallet = async (coinType) => {
  const res = await httpGet(httpUrl.serverWalletInfo, [coinType], {});
  const data = res && res.data;
  if (!data || !data.address) {
    throw new Error("WALLET_INFO_FAIL");
  }
  return data;
};
